import { ErrorView } from '@paypalcorp/pp-react'
import React from 'react'

const CleverError = () => {
  return (
    <ErrorView
      title="Something Went Wrong"
      subTitle=""
      primaryButtonOptions={{
        title: 'Retry',
        onClick: () => location.reload(),
      }}
    />
  )
}

export default CleverError
